var render = function render(){var _vm=this,_c=_vm._self._c;return _c('framed-layout',{scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('a',{staticClass:"btn-circle cursor-pointer",on:{"click":_vm.goBack}},[_c('i',{staticClass:"text-xl text-blue-500 pi pi-times"})])]},proxy:true}])},[_c('div',{staticClass:"max-w-5xl mx-auto"},[_c('profile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }